import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import { Section } from '@/teams/portfolio/components/section/section/section.tsx'
import '@/teams/portfolio/components/section/contact-section/contact-section.scss'

export function ContactSection() {
	const { t } = useTranslation()

	return (
		// biome-ignore lint/correctness/useUniqueElementIds: Static ID needed for URL anchor navigation
		<Section ariaLabel={t('portfolio.section.contact.ariaLabel')} id='contact'>
			<div className='contact-section'>
				<h2 className='contact-section__title'>
					{t('portfolio.section.contact.title')}
				</h2>
				<p className='contact-section__placeholder'>
					{t('portfolio.section.contact.placeholder')}
				</p>
			</div>
		</Section>
	)
}
